import React, { useState } from "react";
import { Box } from "@mui/material";

import { FirebaseApp } from "firebase/app";
import FaceWithName from "./FaceWithName";
import YoutubeLinkFromUrl from "./YoutubeLinkFromUrl";
import MildomLinkFromUrl from "./MildomLinkFromUrl";

type Props = {
  firebaseApp: FirebaseApp;
};
function WikiSyntaxGenerator(props: Props) {
  const [name, setName] = useState("");
  const { firebaseApp } = props;

  return (
    <Box>
      <FaceWithName
        name={name}
        setName={setName}
        id="face-with-name"
        label="wiki用書式"
        tooltip="クリップボードにコピー"
        firebaseApp={firebaseApp}
      />
      <YoutubeLinkFromUrl />
      <MildomLinkFromUrl />
    </Box>
  );
}

export default WikiSyntaxGenerator;
